const OutcomeLabelHandicap = {
    title: 'Example JSON',
    expectedOutput: 'Arsenal pk',
    initialDisplayedCode: `{
      "outcomeId": 2950948551,
      "betOffer": {
        "id": 883929922,
        "betOfferType": {
          "id": 1,`,
    moreCode: `
    "name": "betOffer name"
  },
  "place": false,
    "outcomes": [
      {
        "id": 2950948551,
        "label": "Arsenal",
        "line": 0,
        "type": "OT_ONE_CROSS"
      },
      {
        "id": 2950948554,
        "label": "Feyenoord",
        "line": 230,
        "type": "OT_ONE_TWO"
      }
    ]
  },
  "enableHandicapPickem": true,
  "event": {
    "awayName": "EventAwayName",
    "homeName": "EventHomeName"
  }
}`,
};

export default OutcomeLabelHandicap;
